/**
 * Standard funnel event names
 * These can be overridden per brand in config.analytics.events
 */
export const FUNNEL_EVENTS = {
  TUNNEL_START: 'tunnel_start',
  USER_FORM_STARTED: 'user_form_started',
  USER_FORM_COMPLETED: 'user_form_completed',
  OFFER_SELECTED: 'offer_selected',
  OPTIONS_SELECTED: 'options_selected',
  PROMO_CODE_APPLIED: 'promo_code_applied',
  PROMO_CODE_ERROR: 'promo_code_error',
  SEPA_SUBMITTED: 'sepa_submitted',
  CONTRACT_VIEWED: 'contract_viewed',
  CONTRACT_SIGNED: 'contract_signed',
  PAYMENT_STARTED: 'payment_started',
  PAYMENT_COMPLETED: 'payment_completed',
  PAYMENT_ERROR: 'payment_error',
  CLUB_TRANSFER_COMPLETED: 'club_transfer_completed',
  TUNNEL_COMPLETED: 'tunnel_completed'
};

/**
 * Funnel step names for virtual pageviews
 */
export const FUNNEL_STEPS = {
  CLUB_SELECTION: 'club_selection',
  USER_FORM: 'user_form',
  PLANS: 'plans',
  OPTIONS: 'options',
  REGULARS: 'regulars',
  RECAP: 'recap',
  SEPA: 'sepa',
  CONTRACT: 'contract',
  PAYMENT: 'payment',
  PHOTO: 'photo',
  CONFIRMATION: 'confirmation'
};
